import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import useSnackbar from 'components/organisms/Snackbar/useSnackbar'

const useCheckboxSelection = (fetchAllData = async () => {}) => {
  const [selected, setSelected] = useState([])

  const { showSnackbarMessage } = useSnackbar()
  const { t } = useTranslation()

  const selectAllClick = async (event) => {
    if (event.target.checked && selected.length > 0) {
      setSelected([])
      return
    }

    if (event.target.checked) {
      try {
        const items = await fetchAllData()
        setSelected(items)
      } catch (error) {
        //console.error(`Failed to fetch items: ${error.message}`)
        showSnackbarMessage({
          message: t('common.error.selectAll'),
          severity: 'error',
        })
      }
      return
    }
    setSelected([])
  }
  const selectClick = (value, attribute) => {
    setSelected((prevSelected) => {
      const selectedIndex = attribute
        ? prevSelected.findIndex(
            (item) => item?.[attribute] === value?.[attribute]
          )
        : prevSelected.indexOf(value)
      let newSelected = []

      if (selectedIndex === -1) {
        newSelected = newSelected.concat(prevSelected, value)
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(prevSelected.slice(1))
      } else if (selectedIndex === prevSelected.length - 1) {
        newSelected = newSelected.concat(prevSelected.slice(0, -1))
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          prevSelected.slice(0, selectedIndex),
          prevSelected.slice(selectedIndex + 1)
        )
      }

      return newSelected
    })
  }

  const resetSelected = useCallback(() => setSelected([]), [])

  const isSelected = useCallback(
    (value, attribute) =>
      attribute
        ? selected.findIndex(
            (item) => item?.[attribute] === value?.[attribute]
          ) !== -1
        : selected.indexOf(value) !== -1,
    [selected]
  )

  return {
    selected,
    selectAllClick,
    selectClick,
    isSelected,
    resetSelected,
  }
}

export default useCheckboxSelection
